export const MINIMIZED_TITLE = 'Видеофайл';
export const MINIMIZED_DESC = 'Ссылки и файлы';
